import { graphql } from '../../graphql';

export const getItemId = graphql(`
  query ItemId($id: ID!) {
    item(id: $id) {
      id
    }
  }
`);

export const getItemPage = graphql(`
  query ItemPageBase($id: ID!) {
    regions(cityId: 1) {
      id
      name
      latitude
      longitude
      slug
    }
    cities(filter: { scope: UNPOPULAR }, limit: 80) {
      id
      name
      slug
    }
    item(id: $id) {
      ...SSRCurrentItemFields
    }
  }
`);

export const invalidateItemPageData = graphql(`
  query InvalidateItemPageData($id: ID!) {
    item(id: $id) {
      ...SSRCurrentItemFields
    }
  }
`);

export const getCurrentItem = graphql(`
  query CurrentItem($id: ID!) {
    item(id: $id) {
      id
      address
      actions
      isReported
      isMine
      isBookmarked
      description
      isLeased
      rooms
      floor
      floors
      metaTags {
        name
        content
      }
      phones {
        ... on MaskedPhone {
          value
        }
        ... on Phone {
          value
        }
      }
      hasBillOfSale
      hasMortgage
      hasRepair
      hasInternalLoan
      mortgageTerms {
        monthlyPayment
        interestRate
        remainingYears
        remainingMonths
      }
      state
      isExpiredManually
      contactName
      contactTypeName
      buildingTypeName
      longitude
      latitude
      path
      paidServices {
        id
        isResetHitsAvailable
        options {
          id
          name
          price
          priceWithDiscount(paymentMethodId: "wallet")
        }
        paymentMethods {
          id
          balance
          name
          cardToken
          iconUrl
          isAppleGooglePayEnabled
        }
        activeUntil
        title
        targetType
      }
      business {
        ... on Agency {
          id
          itemsCount
          logoUrl
          name
          path
          viewsCount
          schedule
          contactAddress
          latitude
          longitude
          city {
            name
          }
        }
        ... on Residence {
          id
          website
          logoUrl
          contactEmail
          path
          companyName
          apartments {
            nodes {
              area
            }
          }
          deadline
          hasBillOfSale
          price {
            currency
            total {
              maximum
              minimum
            }
          }
          address
          lat
          lng
          schedule
          city {
            name
          }
        }
      }
      nearestLocations {
        ... on Location {
          path
          fullName
          id
        }
        ... on City {
          path
          name
          id
        }
      }
      updatedAt
      expiresAt
      views
      isFeatured
      isVipped
      rejectReason {
        message
        duplicateOf {
          id
          rooms
          floor
          path
          isLeased
          isPaidDaily
          location {
            fullName
          }
          area {
            units
            value
          }
          price {
            currency
            total
          }
          photos(limit: 1) {
            thumbnail
          }
        }
      }
      location {
        fullName
        path
      }
      landArea {
        units
        value
      }
      area {
        units
        value
      }
      price {
        currency
        perAre
        total
      }
      isPaidDaily
      company {
        id
        name
        targetType
      }
      breadcrumbs {
        name
        path
      }
      category {
        id
        hasFloor
        hasLandArea
        name
        pluralName
        slug
        title
      }
      city {
        id
        name
        path
        slug
      }
      photos {
        full
        f660x496
        thumbnail
      }
    }
    flashMessages {
      type
      message
    }
  }
`);

export const getUserRelatedItem = graphql(`
  query UserRelatedItem($id: ID!) {
    item(id: $id) {
      id
      updatedAt
      views
      longitude
      latitude
      actions
      isReported
      isMine
      isBookmarked
      rejectReason {
        message
        duplicateOf {
          id
          rooms
          floor
          path
          isLeased
          isPaidDaily
          location {
            fullName
          }
          area {
            units
            value
          }
          price {
            currency
            total
          }
          photos(limit: 1) {
            thumbnail
          }
        }
      }
      paidServices {
        id
        isResetHitsAvailable
        options {
          id
          name
          price
          priceWithDiscount(paymentMethodId: "wallet")
        }
        paymentMethods {
          id
          balance
          name
          cardToken
          iconUrl
        }
        activeUntil
        title
        targetType
      }
      phones {
        ... on MaskedPhone {
          value
        }
        ... on Phone {
          value
        }
      }
      expiresAt
    }
  }
`);

export const getReportReasonsQuery = graphql(`
  query ReportReasons {
    reportReasons {
      id
      reason
    }
  }
`);
